import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { confirmOrder } from '../helpers/confirm-order';

interface ConfirmOrderFnPayload {
    orderId: string;
}

export type ConfirmOrderFn = (payload: ConfirmOrderFnPayload) => Promise<{
    newSubscription: {
        subscriptionId: string;
    };
}>;

export function initConfirmOrderFn({
    dependencies,
}: DomainInitPayload): ConfirmOrderFn {
    const { appEventSdk } = dependencies;
    return async ({ orderId }) => {
        try {
            const result = await confirmOrder({ orderId }, dependencies);
            if (!result?.newSubscription?.subscriptionId) {
                throw new Error('New subscription not created.');
            }
            const subscriptionId = result.newSubscription.subscriptionId;
            appEventSdk.trackEvent({
                event: 'customer-info',
                customerInfo: {
                    customerType: 'SXIR_SELFPAY',
                    subscriptions: [
                        {
                            id: subscriptionId,
                        },
                    ],
                },
            });
            appEventSdk.trackEvent({
                event: 'order-confirmed',
                subscriptionInfo: [
                    {
                        id: subscriptionId,
                        orderId,
                    },
                ],
            });
            // TODO: consider changing this to just return the subscriptionId if that is all the caller really needs
            return {
                newSubscription: {
                    subscriptionId: result.newSubscription.subscriptionId,
                },
            };
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
